import React, { useEffect, useState } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { getAuth, onAuthStateChanged } from 'firebase/auth';
import { useConfig } from '../contexts/ConfigContext';
import LoadingAnimation from './LoadingAnimation';

const ADMIN_SECTIONS = [
  { title: 'Events', description: 'Create and edit upcoming events', path: '/admin/events' },
  { title: 'Reflections', description: 'Write and manage articles', path: '/admin/reflections' },
  { title: 'Prayers', description: 'Manage the prayers library', path: '/admin/prayers' },
  { title: 'Resources', description: 'Upload and manage PDFs', path: '/admin/resources' },
  { title: 'Gallery', description: 'Upload and manage photos', path: '/admin/gallery' },
  { title: 'Prayer Requests', description: 'View submitted prayer requests', path: '/admin/prayer-requests' },
  { title: 'Config', description: 'Edit site text and admin emails', path: '/admin/config' },
];

const Admin = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const config = useConfig();
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const auth = getAuth();
    const unsubscribe = onAuthStateChanged(auth, (user) => {
      if (!user) {
        navigate('/login', { state: { from: location.pathname } });
      } else if (config.configLoaded && config.adminEmails.length > 0 && !config.adminEmails.includes(user.email)) {
        navigate('/');
      } else if (config.configLoaded) {
        setLoading(false);
      }
    });
    return () => unsubscribe();
  }, [config.configLoaded, config.adminEmails]); // eslint-disable-line react-hooks/exhaustive-deps

  if (loading) return <div style={{ minHeight: '100vh' }}><LoadingAnimation /></div>;

  return (
    <div className="stt-admin-page">
      <h1 className="stt-admin-title">Admin</h1>
      <p style={{ color: '#666', marginBottom: '8px', fontSize: '0.9rem' }}>
        Southie Totus Tuus site management
      </p>
      <hr />

      <div className="stt-admin-nav-grid">
        {ADMIN_SECTIONS.map(section => (
          <a
            key={section.path}
            href={section.path}
            className="stt-admin-nav-card"
          >
            <h3>{section.title}</h3>
            <p>{section.description}</p>
          </a>
        ))}
      </div>
    </div>
  );
};

export default Admin;
